// removed by extract-text-webpack-plugin
module.exports = {"container":"container___3vAzi","content":"content___2CkG6","newModel":"newModel___2c4rU","header":"header___3iq4O","saveButton":"saveButton___6OVEZ","errorText":"errorText___2ZOkt","checkBoxContainer":"checkBoxContainer___30bHp"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/CreateEntity/CreateEntity.module.css
// module id = 215
// module chunks = 0